import { h } from 'preact';
import PureComponent from './PureComponent';
import getJSON from '../utils/get-json';
import { select, geoPath, } from "d3";

import loadAssetURL from '../utils/load-asset-url';

const point_marker = loadAssetURL('point-marker');

class DistrictMapMini extends PureComponent {
  constructor() {
    super();

    this.state = {
      geometry: null,
      isLoading: false,
      simplified_geo: null,
    }
  }

  drawMap() {
    const { geometry, coordinates, projection, width } = this.props;
    const office = geometry.properties.stats.office;
    const district = geometry.properties.district;
    const id = `district-map__zoomed__${office}__${district}`;
    let cities = geometry.properties.cities;
    cities.forEach(city => {
      city.name_array = city.name_display.split('\\n');
    });

    const src = `https://graphics.texastribune.org/graphics/voter-guide-primaries-2023-12/assets/map-images/${office}/${office}-${district}.png`
    // const src = `../assets/map-images/${office}/${office}-${district}.png`
    const baseMap = select(`#${id}`).select('.basemap')
    baseMap.select("img")
      .attr("src", src)
      .attr('width', width)

    const markerSvg = select(`#${id}`).select('.marker').select('svg');
    markerSvg.attr('width', width).attr('height', width);


    const clipPath = markerSvg.select('clipPath').select('circle')
      .attr('cx', width / 2)
      .attr('cy', width / 2)
      .attr('r', width / 2)

    const cityNamesG = markerSvg.select('.marker__cities')
      .attr('clip-path', "url(#cut-off-circle")

    const citiesText = cityNamesG.select('.text')
      .selectAll('g')
      .data(cities)
      .join('g')
      .attr('transform', d => `translate(${projection([d.long, d.lat])[0]}, ${projection([d.long, d.lat])[1] - (d.name_array.length - 1) * 5})`)
      .attr('text-anchor', 'middle')
      .attr('class', d => `city-name__size-${d.size}`)

    citiesText.selectAll('text')
      .data(d => d.name_array)
      .join('text')
      .attr('x', 0)
      .attr('y', (d, i) => i * 10)
      .text(d => d);

    const citiesOutline = cityNamesG.select('.outline')
      .selectAll('g')
      .data(cities)
      .join('g')
      .attr('transform', d => `translate(${projection([d.long, d.lat])[0]}, ${projection([d.long, d.lat])[1] - (d.name_array.length - 1) * 5})`)
      .attr('text-anchor', 'middle')
      .attr('class', d => `city-name__size-${d.size}`)

    citiesOutline.selectAll('text')
      .data(d => d.name_array)
      .join('text')
      .attr('x', 0)
      .attr('y', (d, i) => i * 10)
      .text(d => d);

    const path = geoPath(projection)

    markerSvg.select('.marker__district-boundary').select('.outline')
      .attr("d", path(geometry.geometry_simple))
      .attr('stroke', "white")
      .attr('stroke-width', 3.5)
      .attr('stroke-opacity', 0.66)
      .attr('fill', 'none')
      .attr('stroke-linejoin', 'round')

    markerSvg.select('.marker__district-boundary').select('.stroke')
      .attr("d", path(geometry.geometry_simple))
      .attr('stroke', "black")
      .attr('stroke-width', 1.5)
      .attr('fill', 'none')
      .attr('stroke-linejoin', 'round')

    const markerG = markerSvg.select('g.marker__pointer');
    coordinates.pixel = projection([coordinates.longitude, coordinates.latitude]);
    const x = coordinates.pixel[0] - 6;
    const y = coordinates.pixel[1] - 18;
    markerG.attr('transform', `translate(${x}, ${y})`)

    markerG.select("image")
      .attr("xlink:href", point_marker)
      .attr('width', 12)
      .attr('height', 18)
  }

  componentDidMount() {
    this.drawMap();
  }

  componentDidUpdate(prevProps) {
    if (this.props !== prevProps) {
      this.drawMap();
    }
  }

  render() {
    const { geometry } = this.props;

    const office = geometry.properties.stats.office;
    const district = geometry.properties.district;
    const id = `district-map__zoomed__${office}__${district}`

    return (
      <div id={id} class="district-map__zoomed">
        <div class="basemap">
          <img />
        </div>
        <div class="marker">
          <svg>
            <defs>
              <clipPath id="cut-off-circle">
                <circle></circle>
              </clipPath>
            </defs>
            <g class="marker__cities">
              <g class="outline"></g>
              <g class="text"></g>
            </g>
            <g class="marker__district-boundary">
              <path class="outline"></path>
              <path class="stroke"></path>
            </g>
            <g class="marker__pointer">
              <image></image>
            </g>
          </svg>
        </div>
      </div>
    );
  }
}

export default DistrictMapMini;